import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import "./style.css"

const ToastError = ({ title, showTitle, showArrow, ...props }) => {
    const navigate = useNavigate()
    return (
        <div>
            Oops! Something went wrong. <span onClick={() => {
                navigate("/indi-support");
                toast.dismiss();
            }} style={{ color: "red" }}>Report a Bug</span>
        </div>
    );
};

export default ToastError;